import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FaDollarSign, FaBook, FaUsers, FaCalendar } from 'react-icons/fa';
import studentId from '../config';

const FeeStructure = ({}) => {
  const [feeData, setFeeData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
 const sessionId = localStorage.getItem("currentSessionId");
  useEffect(() => {
    const fetchStudentDetails = async () => {
      try {
        // Fetch student details
        const studentResponse = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/students/getStudents/${studentId}`,
          { params: { sessionId } }
        );
        const feeStructureId = studentResponse.data.feeStructureId;

        if (!feeStructureId) {
          throw new Error('Fee structure not found for this student');
        }

        // Fetch fee structure
        const feeResponse = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/feeStructures/getFeeStructureById/${feeStructureId}`,
          { params: { sessionId } }
        );
        setFeeData(feeResponse.data);
        setLoading(false);
      } catch (error) {
        setError(error.message || 'Error fetching data');
        setLoading(false);
      }
    };

    fetchStudentDetails();
  }, [studentId]);

  if (loading) return <div className="text-center mt-8 text-sm">Loading...</div>;

  // 🔥 Updated error text size → 14px
  if (error)
    return (
      <div className="text-center mt-8 text-red-500 text-[14px]">
        {error}
      </div>
    );

  return (
    <div className="container mx-auto p-2 max-h-screen">
      <h1 className="text-2xl md:text-3xl font-bold text-center">Fee Structure</h1>

      <div className="overflow-x-auto">
        <table className="table-auto w-full border-collapse border border-gray-200 shadow-md rounded-lg">
          <thead>
            <tr>
              <th className="border border-gray-200 px-4 py-2">Class</th>
              <th className="border border-gray-200 px-4 py-2">Student Type</th>
              <th className="border border-gray-200 px-4 py-2">Total Fees</th>
              <th className="border border-gray-200 px-4 py-2">Medium</th>
              <th className="border border-gray-200 px-4 py-2">Fee Heads</th>
              <th className="border border-gray-200 px-4 py-2">Monthly Fees</th>
              <th className="border border-gray-200 px-4 py-2">Remarks</th>
            </tr>
          </thead>

          <tbody>
            <tr className="bg-white transition-colors duration-200 hover:bg-gray-50">
              <td className="border border-gray-200 px-4 py-2">{feeData.class}</td>
              <td className="border border-gray-200 px-4 py-2">{feeData.studentType}</td>
              <td className="border border-gray-200 px-4 py-2">₹{feeData.totalfees}</td>
              <td className="border border-gray-200 px-4 py-2">{feeData.medium}</td>

              <td className="border border-gray-200 px-4 py-2">
                {Object.entries(feeData.feeHeadValues).map(([key, value]) => (
                  <div key={key} className="flex justify-between text-sm">
                    <span>{key}</span>
                    <span>₹{value}</span>
                  </div>
                ))}
              </td>

              <td className="border border-gray-200 px-4 py-2">
  {[
    "April", "May", "June", "July", "August", "September",
    "October", "November", "December", "January", "February", "March"
  ].map((monthName, i) => (
    <div key={i} className="flex justify-between text-sm">
      <span>{monthName}</span>
      <span>₹{feeData[`month${i + 1}`]}</span>
    </div>
  ))}
</td>


              <td className="border border-gray-200 px-4 py-2 text-sm">
                {feeData.remarks || 'No Remarks'}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default FeeStructure;
